// api url branches
// Home 
export const HOME = 'home/'
export const HAPPYMETER = 'home/happy_meter/'
export const CLOCKIFY = 'home/clockify/'
export const EMPLOYEE_TRACKER = `tracker/employee/clockin/`;
export const NOTICE_BOARD = 'administrator/notice_board/'
export const PASSWORD_POLICY = 'administrator/password_policy/'
export const EMPLOYER = 'administrator/company/';
export const USERGROUP =  'administrator/user_group/'
export const USERPERMISSION = 'administrator/user_permissions/'
export const ORGANIZATION_DOCUMENTS = 'administrator/documents'

// Master Screen API
export const NEW_EMPLOYEE_TYPE = `master/employee_type/`;
export const NEW_EMPLOYEE_DEPARTMENT = `master/departments/`;
export const NEW_EMPLOYEE_DESIGNATION = `master/designation/`;
export const NEW_EMPLOYEE_LEAVE_POLICY = `master/leave_type/`;
export const NEW_EMPLOYEE_GROUP = `master/group/`;
export const NEW_REIMBURSEMENTS_CONFIG = `master/reimbursement_type/`;
export const NEW_ASSET_MANAGEMENT = `master/asset_type/`;
export const NEW_MASTER_ASSET_CATEGORY = `master/asset_category/`;
export const NEW_MASTER_ASSET_SUBCATEGORY = `master/asset_sub_category/`;
export const NEW_LETTER_TYPE_API = `master/letter_type/`;
export const NEW_LETTER_TEMPLATE_API = `master/letter_template/`;

// config
export const NEW_EMPLOYEE_SHIFT = 'configuration/shift/'
export const NEW_HOLIDAY_SETUP = 'configuration/holiday/'
export const NEW_SALARY_TEMPLATE = 'configuration/salary_template/'
export const NEW_EMPLOYEE_WEEK_OFF = 'configuration/weekoff/'
export const NEW_SALARY_COMPONENT = 'configuration/salary_component/'
export const NEW_PAYROLL_PERIOD = 'configuration/payroll_period/'
export const NEW_CUSTOM_CONFIGURATION = 'configuration/custom_configuration/'
 
// Employee Screen API
export const NEW_EMPLOYEE_PERSONAL_INFO = `employee/info/`;
export const NEW_EMPLOYEE_LEAVE = `employee/leave_request/`;
export const NEW_EMPLOYEE_GET_REIMBURSEMENTS = `employee/reimbursement_request/`;
export const NEW_EMPLOYEE_GET_ADVANCE_SALARY = `employee/advance_salary_request/`;
export const NEW_EMPLOYEE_SUBORDINATE_EMPLOYEELIST= `employee/subordinates/employee_list/`;
export const NEW_EMPLOYEE_RESIGNATION_REQUEST= `employee/resignation_request/`;
export const NEW_EMPLOYEE_TDS_DECLARATION = `employee/tds_declaration/`;
export const NEW_EMPLOYEE_CANDIDATE_INFO = `employee/candidate/info/`;
export const NEW_EMPLOYEE_INTERN_INFO = `employee/interns/info/`;
export const NEW_EMPLOYEE_PAY_SLIP = `employee/payslip/`;
export const NEW_EMPLOYEE_ONBOARDING = `employee/offer_letter/`
export const NEW_INTERN_ONBOARDING = `employee/intern_offer_letter/`

//employee End Point
export const NEW_LEAVE_APPROVAL = `employee/leave_approval/`;
export const NEW_ADVANCE_SALARY_APPROVAL = `employee/advance_salary_approval/`;
export const NEW_REIMBURSEMENT_APPROVAL = `employee/reimbursement_approval/`;
export const NEW_RESIGNATION_APPROVAL =`employee/resignation_approval/`;

// currently this screen is removed and changed completely
export const NEW_APPROVAL_INBOX = `employee/recent_approvals/`

// payroll
export const NEW_PAYROLL_RUN_GET = `payroll/run_payroll/`;
export const NEW_PAYROLL_PROCESS = `payroll/payroll_process/`;
export const NEW_PAYROLL_PUBLISH = `payroll/publish_payslip/`;
export const NEW_PAYROLL_PAY_SLIP = `payroll/payslip/`;

// Attendance
export const NEW_EMPLOYEE_ATTENDANCE_DAILY =  `attendance/`;
export const NEW_EMPLOYEE_ATTENDANCE_LOG = `attendance/attendance_log/`;
export const NEW_EMPLOYEE_ATTENDANCE_CORRECTION_REQUEST = `attendance/correction-request/`;

// Asset Management
export const NEW_ASSET_REGISTRY = `asset_management/asset_registry/`;
export const NEW_ASSET_EMPLOYEE_AUDIT = `asset_management/employee_audit/`;

// Roaster
export const NEW_ROSTERING_GET = `rostering/`;
export const NEW_INDIVIDUAL_ROSTERING_GET = ``;

// reports
export const DAYWISE_ATTENDANCE_REPORTS = 'reports/attendance/day/'
export const MONTHWISE_ATTENDANCE_REPORTS = 'reports/attendance/month/'
export const SALARYPROCESS_BANK_REPORTS = 'reports/bank/'
export const SALARYSUMMARY_REPORTS = 'reports/salary_summary/'
export const PAYROLL_DETAIL_REPORTS = 'reports/payroll/'
export const EMPLOYEE_ESI_REPORTS = 'reports/esi/'
export const EMPLOYEE_PF_REPORTS = 'reports/pf/'
export const MUSTER_ROLL_REPORT = 'reports/muster_roll/'
export const EMPLOYEE_CREDIT_DEBIT = 'reports/credit_debit/'
export const EMPLOYEE_ATTENDANCE_CORRECTION = 'reports/attendance/correction/'
export const SUBORDINATES_REPORTS = 'reports/subordinates/'
export const ROSTERING_REPORT = 'reports/roster_report/'
export const LEAVE_PERMISSION_REPORT = 'reports/approved_leaves_report/'

//Employee Migration
export const NEW_EMPLOYEE_MIGRATION_LIST = `data_migration/employee_migration/list/`;

//myplans

// dependency apis
// get postal pincode
export const POSTAL_PINCODE = "https://api.postalpincode.in/pincode/";

//asset registry city - floor - block - room 
export const ASSET_CITY = `asset_management/asset_city/`;
export const ASSET_BLOCK = `asset_management/asset_block/`;
export const ASSET_FLOOR = `asset_management/asset_floor/`;
export const ASSET_ROOM = `asset_management/asset_room/`;